<template>
    <v-dialog v-model="dialog" width="100%" style="margin: 100px !important;" persistent>
        <v-card>

            <v-app-bar class="mb-5" flat color="transparent">
                <v-btn large icon >
                    <v-icon color="primary" @click="$emit('cancel')">mdi-arrow-left</v-icon>
                </v-btn>

                <v-toolbar-title class="title">
                    Itens Nota Fiscal
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn color="primary" @click="handleSave">
                    <span>
                        Salvar
                    </span>
                </v-btn>
        
            </v-app-bar>

            
            <v-spacer></v-spacer>

            <!-- <v-btn color="primary" @click="handleSave">
                <span>
                    Salvar
                </span>
            </v-btn> -->

            <v-form :key="componentKey">
                <!-- <v-container> -->
                    <v-row dense>
                        <!-- Código -->
                        <!-- <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="form.codigo" label="Código" outlined />
                        </v-col> -->

                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="form.sequencia" label="Seq Item" outlined :readonly="true" />
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-model="form.descricao" 
                                label="Item" 
                                dense 
                                outlined
                                disabled
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                v-model="form.pedidodecompra"
                                label="Pedido de compra"
                                outlined
                            />
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                v-model="form.sequenciaPedidoDeCompra"
                                label="Item no Pedido de Compra"
                                outlined
                            />
                        </v-col>

                        <!-- Quantidade -->
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field @blur="recalcularAoTrocarTab(tab)" v-model="form.quantidade" label="Quantidade" outlined />
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="form.unidadeSigla" label="Unidade" outlined />
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <v-autocomplete
                                v-model="form.ncm"
                                :items="itemsNcm"
                                item-text="codigo"
                                item-value="codigo"
                                label="NCM"
                                dense
                                outlined
                                clearable
                            >
                                <template v-slot:item="{ item }">
                                    <div class="d-flex flex-column">
                                        <div class="font-weight-bold">{{ item.codigo }}</div>
                                        <div>{{ item.descricao }}</div>
                                    </div>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <v-autocomplete
                                v-model="form.cest"
                                :items="cests"
                                item-text="codigo"
                                item-value="codigo"
                                label="CEST"
                                dense
                                outlined
                                clearable
                            >
                                <template v-slot:item="{ item }">
                                    <div class="d-flex flex-column">
                                        <div class="font-weight-bold">{{ item.codigo }}</div>
                                        <div>{{ item.descricao }}</div>
                                    </div>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <!-- Valor Unitário -->
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field @blur="recalcularAoTrocarTab(tab)" v-money="money" v-model="form.valorUnitario" label="Valor Unitário" outlined />
                        </v-col>

                        <!-- Valor Total -->
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-money="money" 
                                v-model="form.valorTotal" 
                                label="Valor Total" 
                                readonly
                                outlined 
                            />
                        </v-col>

                        <!-- Observações -->
                        <v-col cols="12" sm="12">
                            <v-textarea v-model="form.observacao" label="Informações Adicionais" outlined rows="3" />
                        </v-col>

                        <v-col cols="12" sm="12"  v-if="isNfReferenciada">
                            <v-switch label="Aplicar Calculos" v-model="addCalc"></v-switch>
                        </v-col>
                    </v-row>

                    <v-card>
                        <v-tabs v-model="tab" background-color="primary" dark>
                            <!-- <v-tab>Pedido de Compra</v-tab>
                            <v-tab>Pedido de Venda</v-tab> -->
                            <v-tab v-show="addCalc || isNfRemessa || isDuplicating">IPI</v-tab>
                            <v-tab v-show="addCalc || isNfRemessa || isDuplicating">ICMS</v-tab>
                            <v-tab v-show="addCalc || isNfRemessa || isDuplicating">PIS</v-tab>
                            <v-tab v-show="addCalc || isNfRemessa || isDuplicating">COFINS</v-tab>
                            <v-tab>Imposto de Transporte</v-tab>
                            <v-tab>IBS/CBS</v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab">
                            <!-- Pedido de Compra -->
                            <!-- <v-tab-item>
                                <v-card flat>
                                    <v-card-text>
                                        <v-text-field label="Pedido de Compra" v-model="form.pedidodecompra" />
                                        <v-text-field label="Sequência do Pedido de Compra"
                                            v-model="form.sequenciaPedidoDeCompra" />
                                    </v-card-text>
                                </v-card>
                            </v-tab-item> -->

                            <!-- Pedido de Venda -->
                            <!-- <v-tab-item>
                                <v-card flat>
                                    <v-card-text>
                                        <v-text-field label="Pedido de Venda" v-model="form.pedidodevenda" />
                                        <v-text-field label="Itens do Pedido de Venda"
                                            v-model="form.itensPedidoDeVenda" />
                                    </v-card-text>
                                </v-card>
                            </v-tab-item> -->

                            <!-- IPI -->
                            <v-tab-item>
                                <v-card flat>
                                    <v-card-text>

                                        <v-combobox 
                                            @change="calcularIPI()" 
                                            :items="ipiOptions" 
                                            label="CTS IPI" v-model="form.ctsIpi" 
                                        />

                                        <v-checkbox
                                            v-model="form.ipiCompoeBaseCalculo"
                                            label="IPI Compõe Base de Cálculo"
                                            hide-details
                                            class="mt-0"
                                            @change="handleComposicaoBaseChange('ipi')"
                                        />

                                        <v-text-field 
                                            label="Base de Cálculo IPI" 
                                            v-model="form.ipiBaseCalculo" 
                                            v-money="money" 

                                            
                                        />

                                        <v-text-field 
                                            label="Alíquota IPI (%)" 
                                            v-model="form.ipiPercentual" 
                                            @blur="calcularIPI()"
                                        />

                                        <v-text-field 
                                            label="Valor do IPI" 
                                            v-model="form.ipiValor" 
                                            v-money="money" 
                                            readonly 
                                        />
                                    </v-card-text> 
                                </v-card>
                            </v-tab-item>

                            <!-- ICMS -->
                            <v-tab-item :disabled="!isNfRemessa && !isDuplicating">
                                <v-card flat>
                                    <v-card-text>
                                        <v-combobox @change="calcularICMS()" :items="icmsOptions" label="CTS ICMS" v-model="form.ctsIcms" />

                                        <v-text-field 
                                            v-mask="'##,##'"
                                            v-show="form.ctsIcms == '20 - Redução de base'"
                                            label="% Redução da Base (se houver)" 
                                            v-model="form.icmsPercentualBaseCalculo" 
                                            @blur="calcularICMS()"
                                        />

                                        <v-combobox
                                            v-model="form.modalidadeDeterminacao"
                                            label="Modalidade Determinação"
                                            :items="modalidadeDeterminacaoOptions"
                                            v-if="form.ctsIcms == '10 - Tributada com Substituição Tributária'"
                                            @change="calcularICMS()"
                                        ></v-combobox>

                                        <v-text-field 
                                            label="MVA (%)" 
                                            v-model="form.mva" 
                                            @blur="calcularICMS()" 
                                            v-if="form.ctsIcms == '10 - Tributada com Substituição Tributária' && form.modalidadeDeterminacao == '4 - Margem Valor Agregado (%)'"
                                        />

                                        <v-text-field 
                                            label="Base de Cálculo ICMS" 
                                            v-model="form.icmsBaseCalculo" 
                                            v-money="money" 

                                            
                                        />

                                        <v-text-field 
                                            v-money="money"
                                            label="Resultado Base Cálculo ICMS" 
                                            v-model="form.resultBaseCalcICMS" 
                                            readonly
                                            v-if="form.ctsIcms == '20 - Redução de base' || form.ctsIcms == '10 - Tributada com Substituição Tributária'"
                                        />

                                        <v-text-field 
                                            label="Alíquota CST ICMS (%)" 
                                            v-model="form.aliqDestinoICMS" 
                                            @blur="calcularICMS()" 
                                            v-if="form.ctsIcms == '10 - Tributada com Substituição Tributária'"
                                        />

                                        <v-text-field 
                                            label="Alíquota ICMS (%)" 
                                            v-model="form.icmsPercentual" 
                                            @blur="calcularICMS()" 
                                        />

                                        <v-text-field 
                                            label="Valor do ICMS" 
                                            v-model="form.icmsValor" 
                                            v-money="money" 
                                            readonly 
                                        />

                                    </v-card-text>
                                </v-card>
                            </v-tab-item>

                            <!-- PIS -->
                            <v-tab-item :disabled="!isNfRemessa && !isDuplicating">
                                <v-card flat>
                                    <v-card-text>
                                        <v-combobox @change="calcularPIS()" :items="pisOptions" label="CTS PIS" v-model="form.ctsPis" />
                                        <v-text-field 
                                            label="Base de Cálculo PIS" 
                                            v-model="form.pisBaseCalculo" 
                                            v-money="money" 

                                            
                                        />

                                        <v-text-field 
                                            label="Alíquota PIS (%)" 
                                            v-model="form.pisPercentual" 
                                            @blur="calcularPIS()"
                                        />

                                        <v-text-field 
                                            label="Valor do PIS" 
                                            v-model="form.pisValor" 
                                            v-money="money" 
                                            readonly 
                                        />

                                    </v-card-text>
                                </v-card>
                            </v-tab-item>

                            <!-- COFINS -->
                            <v-tab-item>
                                <v-card flat>
                                    <v-card-text>
                                        <v-combobox @change="calcularCofins()" :items="cofinsOptions" label="CTS Cofins" v-model="form.ctsCofins" />

                                        <v-text-field 
                                            label="Base de Cálculo COFINS" 
                                            v-model="form.cofinsBaseCalculo" 
                                            v-money="money" 

                                            
                                        />

                                        <v-text-field 
                                            label="Alíquota COFINS (%)" 
                                            v-model="form.cofinsPercentual" 
                                            @blur="calcularCofins()"
                                        />

                                        <v-text-field 
                                            label="Valor do COFINS" 
                                            v-model="form.cofinsValor" 
                                            v-money="money" 
                                            readonly 
                                        />
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>

                            <!--Imposto de Transporte -->
                            <v-tab-item>
                                <card flat>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-checkbox
                                                v-model="form.freteCompoeBaseCalculo"
                                                label="Frete Compõe Base de Cálculo"
                                                hide-details
                                                class="mt-2"
                                                @change="handleComposicaoBaseChange('frete')"
                                            />
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field 
                                                v-money="money" 
                                                clearable outlined 
                                                label="Valor Frete"
                                                v-model="form.valorFrete"
                                            />
                                        </v-col>

                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field 
                                                v-money="money" 
                                                clearable outlined 
                                                label="Valor Seguro"
                                                v-model="form.valorSeguro"
                                            />
                                        </v-col>

                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field 
                                                v-money="money" 
                                                clearable outlined 
                                                label="Valor Desconto"
                                                v-model="form.valorDesconto"
                                            />
                                        </v-col>

                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field 
                                                v-money="money" 
                                                clearable outlined 
                                                label="Valor Outros"
                                                v-model="form.valorOutros" 
                                            />
                                        </v-col>

                                    </v-row>
                                </card>
                            </v-tab-item>

                            <!-- IBS/CBS -->
                            <v-tab-item>
                                <card flat>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-autocomplete 
                                                v-model="form.cstIbsCbs" 
                                                :items="notaFiscalItemCST" 
                                                item-text="descricao"
                                                item-value="id" 
                                                label="CST IBS/CBS" 
                                                dense 
                                                outlined 
                                            >
                                                <template v-slot:item="{ item }">
                                                    <div>
                                                        {{ item.codigo }} - {{ item.descricao }}
                                                    </div>
                                                </template>
                                                <template v-slot:selection="{ item }">
                                                    <span>
                                                        {{ item.codigo }} - {{ item.descricao }}
                                                    </span>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-autocomplete 
                                                v-model="form.classificacaoIbsCbs" 
                                                :items="notaFiscalItemClassificacao" 
                                                item-text="descricao"
                                                item-value="id" 
                                                label="Classificação Tributária IBS/CBS" 
                                                dense 
                                                outlined 
                                            >
                                                <template v-slot:item="{ item }">
                                                    <div>
                                                        {{ item.codigo }} - {{ item.descricao }}
                                                    </div>
                                                </template>
                                                <template v-slot:selection="{ item }">
                                                    <span>
                                                        {{ item.codigo }} - {{ item.descricao }}
                                                    </span>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field
                                                clearable outlined 
                                                label="Porcentagem IBS/CBS"
                                                v-model="form.percentualBaseCalculoIbsCbs"
                                                @blur="calcularIbsCbs()"
                                            />
                                        </v-col>

                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field 
                                                v-money="money" 
                                                clearable outlined 
                                                label="Base de Cálculo CBS"
                                                v-model="form.valorBaseCalculoIbsCbs"
                                                readonly
                                            />
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <v-card outlined class="ibs-cbs-summary-card">
                                                <div class="ibs-cbs-summary-card__title">Cálculos IBS/CBS</div>
                                                <div class="ibs-cbs-formula">Base IBS/CBS = (Valor do item - ICMS próprio - PIS - COFINS) x % da base</div>
                                                <div class="ibs-cbs-formula">{{ formatCurrencyFromCents(ibsCbsCalculation.baseNota) }} - {{ formatCurrencyFromCents(ibsCbsCalculation.icmsValor) }} - {{ formatCurrencyFromCents(ibsCbsCalculation.pisValor) }} - {{ formatCurrencyFromCents(ibsCbsCalculation.cofinsValor) }} = {{ formatCurrencyFromCents(ibsCbsCalculation.baseSemTributos) }}</div>
                                                <div class="ibs-cbs-formula">{{ formatCurrencyFromCents(ibsCbsCalculation.baseSemTributos) }} x {{ formatPercentValue(ibsCbsCalculation.percentualBase * 100) }} = {{ formatCurrencyFromCents(ibsCbsCalculation.baseCalculada) }}</div>

                                                <!-- <v-row dense class="mt-1">
                                                    <v-col cols="12" sm="4">
                                                        <div class="ibs-cbs-metric">
                                                            <span class="ibs-cbs-metric__label">Valor CBS</span>
                                                            <strong class="ibs-cbs-metric__value">{{ formatCurrencyFromCents(ibsCbsCalculation.valorCbs) }}</strong>
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <div class="ibs-cbs-metric">
                                                            <span class="ibs-cbs-metric__label">Valor UF</span>
                                                            <strong class="ibs-cbs-metric__value">{{ formatCurrencyFromCents(ibsCbsCalculation.valorUf) }}</strong>
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <div class="ibs-cbs-metric ibs-cbs-metric--highlight">
                                                            <span class="ibs-cbs-metric__label">Total IBS/CBS</span>
                                                            <strong class="ibs-cbs-metric__value">{{ formatCurrencyFromCents(totalIbsCbs) }}</strong>
                                                        </div>
                                                    </v-col>
                                                </v-row> -->
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </card>
                            </v-tab-item>

                        </v-tabs-items>
                    </v-card>
                <!-- </v-container> -->
            </v-form>
        </v-card>
    </v-dialog>
</template>


<script>
import { runAction } from "../../../services/actionService";
import {VMoney} from 'v-money'
import Vue from 'vue';

export default {
    props: ['open', 'itemEdit', 'itemsByRomaneio', 'jobSelected', 'isNfRemessa', 'isNfReferenciada', 'isDuplicating'],
    directives: { money: VMoney },
    data() {
        return {
            loadingAutoComplete: false,
            dialog: false,
            tab: 0,
            addCalc: !this.isNfRemessa && !this.isNfReferenciada ? true : false,
            money: {
                locale: "pt-br",
                decimal: '.',
                thousands: '.',
                prefix: '',
                precision: 2,
                masked: false
            },
            componentKey: 0,
            operacaoFiscalOptions: [],
            itemsData: [],
            fisTipiOptions: [],
            cfops: [],
            cests: [],
            itemsNcm: [],
            notaFiscalItemCST: [],
            notaFiscalItemClassificacao: [],
            ipiOptions: [
                "00 - Entrada com Recuperação de Crédito",
                "01 - Entrada Tributável com Alíquota Zero",
                "02 - Entrada Isenta",
                "03 - Entrada Não-Tributada",
                "04 - Entrada Imune",
                "05 - Entrada com Suspensão",
                "49 - Outras Entradas",
                "50 - Saída Tributada",
                "51 - Saída Tributável com Alíquota Zero",
                "52 - Saída Isenta",
                "53 - Saída Não-Tributada",
                "54 - Saída Imune",
                "55 - Saída com Suspensão",
                "99 - Outras Saídas"
            ],
            icmsOptions: [
                "00 - Tributada integralmente",
                "10 - Tributada com Substituição Tributária",
                "20 - Redução de base",
                "30 - Isenta ou não tributada com cobrança do ICMS por substituição tributária",
                "40 - Isenta",
                "41 - Não tributada",
                "50 - Suspensão",
                "51 - Diferimento",
                "60 - ICMS cobrado anteriormente por substituição tributária",
                "70 - Redução de base com cobrança do ICMS por substituição tributária",
                "90 - Outras"
            ],
            pisOptions: [
                "01 - Operação Tributável com Alíquota Básica",
                "02 - Operação Tributável com Alíquota Diferenciada",
                "03 - Operação Tributável com Alíquota por Unidade de Medida de Produto",
                "04 - Operação Tributável Monofásica - Revenda a Alíquota Zero",
                "05 - Operação Tributável por Substituição Tributária",
                "06 - Operação Tributável a Alíquota Zero",
                "07 - Operação Isenta da Contribuição",
                "08 - Operação sem Incidência da Contribuição",
                "09 - Operação com Suspensão da Contribuição",
                "49 - Outras Operações de Saída",
                "50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno",
                "51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não Tributada no Mercado Interno",
                "52 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação",
                "53 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno",
                "54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação",
                "55 - Operação com Direito a Crédito - Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação",
                "56 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação",
                "60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno",
                "61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno",
                "62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação",
                "63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno",
                "64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação",
                "65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação",
                "66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação",
                "67 - Crédito Presumido - Outras Operações",
                "70 - Operação de Aquisição sem Direito a Crédito",
                "71 - Operação de Aquisição com Isenção",
                "72 - Operação de Aquisição com Suspensão",
                "73 - Operação de Aquisição a Alíquota Zero",
                "74 - Operação de Aquisição sem Incidência da Contribuição",
                "75 - Operação de Aquisição por Substituição Tributária",
                "98 - Outras Operações de Entrada",
                "99 - Outras Operações"
            ],
            cofinsOptions: [
                "01 - Operação Tributável com Alíquota Básica",
                "02 - Operação Tributável com Alíquota Diferenciada",
                "03 - Operação Tributável com Alíquota por Unidade de Medida de Produto",
                "04 - Operação Tributável Monofásica - Revenda a Alíquota Zero",
                "05 - Operação Tributável por Substituição Tributária",
                "06 - Operação Tributável a Alíquota Zero",
                "07 - Operação Isenta da Contribuição",
                "08 - Operação sem Incidência da Contribuição",
                "09 - Operação com Suspensão da Contribuição",
                "49 - Outras Operações de Saída",
                "50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno",
                "51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno",
                "52 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação",
                "53 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno",
                "54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação",
                "55 - Operação com Direito a Crédito - Vinculada a Receitas Não Tributadas no Mercado Interno e de Exportação",
                "56 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação",
                "60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno",
                "61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno",
                "62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação",
                "63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno",
                "64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação",
                "65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação",
                "66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação",
                "67 - Crédito Presumido - Outras Operações",
                "70 - Operação de Aquisição sem Direito a Crédito",
                "71 - Operação de Aquisição com Isenção",
                "72 - Operação de Aquisição com Suspensão",
                "73 - Operação de Aquisição a Alíquota Zero",
                "74 - Operação de Aquisição sem Incidência da Contribuição",
                "75 - Operação de Aquisição por Substituição Tributária",
                "98 - Outras Operações de Entrada",
                "99 - Outras Operações"
            ],
            modalidadeDeterminacaoOptions: [
                "0 - Preço tabelado ou máximo sugerido",
                "1 - Lista Negativa (valor)",
                "2 - Lista Positiva (valor)",
                "3 -  Lista Neutra (valor)",
                "4 - Margem Valor Agregado (%)",
                "5 - Pauta (valor)",
                "6 - Valor da Operação (NT 2019.001)"
            ],
            form: {
                pedidodecompra: '',
                item: '',
                operacaoFiscal: '',
                sequencia: '',
                sequenciaPedidoDeCompra: '',
                pedidodevenda: '',
                itensPedidoDeVenda: '',
                ipiPercentualBaseCalculo: 0,
                ipiBaseCalculo: '',
                ipiPercentual: '',
                ctsIpi: '00 - Tributada integralmente',
                ipiValor: '',
                ipiCompoeBaseCalculo: false,
                ipiAliquota: '',
                ipiAplicaSobreICMS: false,
                ctsIcms: '00 - Tributada integralmente',
                icmsPercentualBaseCalculo: '',
                icmsBaseCalculo: '',
                icmsPercentual: '',
                icmsValor: '',
                icmsAliquota: '',
                ctsPis: '01 - Operação Tributável com Alíquota Básica',
                quantidade: 0,
                pisPercentualBaseCalculo: 0,
                pisBaseCalculo: 0,
                pisPercentual: '1,65',
                valorUnitario: 0,
                valorTotal: 0,
                pisValor: 0,
                ctsCofins: '01 - Operação Tributável com Alíquota Básica',
                cofinsPercentualBaseCalculo: 0,
                cofinsBaseCalculo: 0,
                cofinsPercentual: '',
                cofinsValor: 0,
                ncm: '',
                observacao: '',
                pesoBruto: '',
                pesoLiquido: '',
                cest: '',
                valorFrete: 0,
                freteCompoeBaseCalculo: false,
                valorSeguro: 0,
                valorDesconto: 0,
                valorOutros: 0,
                mva: '',
                resultBaseCalcICMS: '',
                aliqDestinoICMS: '',
                modalidadeDeterminacao: '',
                cstIbsCbs: undefined,
                classificacaoIbsCbs: undefined,
                percentualBaseCalculoIbsCbs: '',
                aliquotaCbs: '',
                valorBaseCalculoIbsCbs: 0,
                valorCbs: 0,
                aliquotaUf: '',
                valorUf: 0
                // resultBaseCalcCofins: ''
            }
        };
    },

    computed: {
        ibsCbsCalculation() {
            const baseNota = this.toNumberBR(this.form.valorTotal);
            const icmsValor = this.toNumberBR(this.form.icmsValor);
            const pisValor = this.toNumberBR(this.form.pisValor);
            const cofinsValor = this.toNumberBR(this.form.cofinsValor);
            const percentualBase = this.form.percentualBaseCalculoIbsCbs === '' || this.form.percentualBaseCalculoIbsCbs == null
                ? 1
                : this.parsePercent(this.form.percentualBaseCalculoIbsCbs);
            const aliquotaCbs = this.parsePercent(this.form.aliquotaCbs);
            const aliquotaUf = this.parsePercent(this.form.aliquotaUf);
            const baseSemTributos = Math.max(baseNota - icmsValor - pisValor - cofinsValor, 0);
            const baseCalculada = Math.round(baseSemTributos * percentualBase);
            const valorCbs = Math.round(baseCalculada * aliquotaCbs);
            const valorUf = Math.round(baseCalculada * aliquotaUf);

            return {
                baseNota,
                icmsValor,
                pisValor,
                cofinsValor,
                percentualBase,
                aliquotaCbs,
                aliquotaUf,
                baseSemTributos,
                baseCalculada,
                valorCbs,
                valorUf
            };
        },

        totalIbsCbs() {
            return this.ibsCbsCalculation.valorCbs + this.ibsCbsCalculation.valorUf;
        },

    },

    methods: {
        getItemsOptions () {
            Vue.prototype.$http.get(`/Entity/OrdemDeServico`, {
                params: {
                    page: 1,
                    limit: this.itemsByRomaneio.length,
                    ids: this.itemsByRomaneio.map((item) => item?._id || item?.item).join(',')
                }
            }).then(response => {
                this.itemsData = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching items:", error);
            });
        },

        getFisTipiOptions () {
            Vue.prototype.$http.get(`/Entity/FisTipi`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.fisTipiOptions = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching FisTipi options:", error);
            });
        },

        getOperacaoFiscalOptions () {
            Vue.prototype.$http.get(`/Entity/FisOper`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.operacaoFiscalOptions = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching Operacao Fiscal options:", error);
            });
        },


        getNcms(){
            Vue.prototype.$http.get(`/Entity/NCM`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.itemsNcm = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching ncms options:", error);
            });
        },

        getCFOPs(){
            Vue.prototype.$http.get(`/Entity/CFOP/search-fields`, {
                params: {
                    page: 1,
                    limit: 9999,
                    searchFields: '[codigo]',
                    value: this.isNfRemessa ? '[5901,6901,5905,6905,5912,6912,5910,6910,5949]' : undefined
                }
            }).then(response => {
                this.cfops = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching cfops options:", error);
            });
        },

        getCests(){
            Vue.prototype.$http.get(`/Entity/CEST`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.cests = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching cets options:", error);
            });
        },

        async getNotaFiscalItemCST() {
            await Vue.prototype.$http.get(`/Entity/NotaFiscalItemCST`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.notaFiscalItemCST = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching Nota Fiscal Item CST options:", error);
            });
        },

        async getNotaFiscalItemClassificacao() {
            await Vue.prototype.$http.get(`/Entity/NotaFiscalItemClassificacaoTributaria`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.notaFiscalItemClassificacao = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching Nota Fiscal Item Classificacao options:", error);
            });
        },


        toNumber(value = 0){

            try{

                // Converte o valor para numérico se falhar é 0
                value = Number(value) || 0;

                // Se for menor que 0 então é 0
                if(value < 0){
                    value = Math.max(0,value);
                }

                return value;

            }catch(e){

                return 0;

            }

        },

        
        toNumberPercentage (value = 0) {

            try{

                value = Number(value) || 0;

                if(value < 0){
                    value = Math.max(0,value);
                }

                if(value > 100){
                    value = Math.max(value,100);
                }
                
                return value;

            } catch(e){

                return 0;

            }

        },

        ipiAliquotaPercentage(){
            this.form.ipiAliquota = this.toPercentage(Number(this.form.ipiAliquota))
            if(isNaN(this.form.ipiAliquota)) this.form.ipiAliquota = 0

            this.componentKey += 1
        },

        icmsAliquotaPercentage(){
            this.form.icmsAliquota = this.toPercentage(Number(this.form.icmsAliquota))
            if(isNaN(this.form.icmsAliquota)) this.form.icmsAliquota = 0

            this.componentKey += 1
        },
        
        toPercentage(number){

            return number.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
        },

        formatCurrencyFromCents(value) {
            const amount = this.toNumberBR(value) / 100;

            return amount.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        },

        formatPercentValue(value) {
            const numericValue = Number(value) || 0;

            return numericValue.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) + '%';
        },

        async handleSave() {
            this.calcularICMS();
            this.calcularPIS();
            this.calcularCofins();

            this.$emit('save', {
                ...this.form,
            });
            // Notifica o componente pai para atualizar o total com impostos
            this.$emit('update-total-com-impostos');
        },

        toNumberBR(value) {
            if (!value) return 0;
            if (typeof value === "number") {
                if (!Number.isFinite(value)) return 0;
                return Number.isInteger(value) ? value : Math.round(value * 100);
            }
            return Number(
                String(value)
                    .replace(/\./g, '') // remove separador de milhar
                    .replace(',', '.')  // transforma vírgula em ponto decimal
            );
        },

        toNumberPercent(value) {
            if (value == null || value === '') return 0;
            if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

            const sanitizedValue = String(value)
                .trim()
                .replace(/\s/g, '')
                .replace(/[^\d,.-]/g, '');

            if (!sanitizedValue) return 0;

            const lastCommaIndex = sanitizedValue.lastIndexOf(',');
            const lastDotIndex = sanitizedValue.lastIndexOf('.');
            const separatorIndex = Math.max(lastCommaIndex, lastDotIndex);

            if (separatorIndex === -1) {
                const integerValue = Number(sanitizedValue.replace(/[.,]/g, ''));
                return Number.isFinite(integerValue) ? integerValue : 0;
            }

            const integerPart = sanitizedValue.slice(0, separatorIndex).replace(/[.,]/g, '');
            const decimalPart = sanitizedValue.slice(separatorIndex + 1).replace(/[.,]/g, '');
            const normalizedValue = `${integerPart || '0'}.${decimalPart || '0'}`;
            const numericValue = Number(normalizedValue);

            return Number.isFinite(numericValue) ? numericValue : 0;
        },

        parsePercent(val) {
            const n = this.toNumberPercent(val);
            if (n === 0) return 0;
            return n / 100;
        },

        getRegraComposicaoBaseCalculo() {
            return {
                ipi: !!this.form.ipiCompoeBaseCalculo,
                frete: !!this.form.freteCompoeBaseCalculo,
            };
        },

        handleComposicaoBaseChange(origem = '') {
            this.recalcularAoTrocarTab(this.tab);
        },

        atualizarBaseCalculoIcmsPorRegra() {
            const valorProdutos = this.toNumberBR(this.form.valorTotal);
            const valorIpi = this.toNumberBR(this.form.ipiValor);
            const valorFrete = this.toNumberBR(this.form.valorFrete);
            const regra = this.getRegraComposicaoBaseCalculo();
            let baseCalculo = valorProdutos;

            if (regra.frete) baseCalculo += valorFrete;
            if (regra.ipi) baseCalculo += valorIpi;

            this.form.icmsBaseCalculo = Math.round(baseCalculo);
        },

        calcularUF() {
            if (this.isNfRemessa) return;

            const baseCalculada = this.toNumberBR(this.form.valorBaseCalculoIbsCbs);
            const aliq = this.parsePercent(this.form.aliquotaUf);

            this.form.valorUf = Math.round(baseCalculada * aliq);
            this.componentKey += 1;
        },

        calcularIbsCbs() {
            if (this.isNfRemessa) return;

            const baseNota = this.toNumberBR(this.form.valorTotal);
            const icmsValor = this.toNumberBR(this.form.icmsValor);
            const pisValor = this.toNumberBR(this.form.pisValor);
            const cofinsValor = this.toNumberBR(this.form.cofinsValor);

            const percentualBase = this.form.percentualBaseCalculoIbsCbs === '' || this.form.percentualBaseCalculoIbsCbs == null
                ? 1
                : this.parsePercent(this.form.percentualBaseCalculoIbsCbs); // % da base
            const aliquotaCbs = this.parsePercent(this.form.aliquotaCbs); // % do imposto

            const baseSemTributos = Math.max(baseNota - icmsValor - pisValor - cofinsValor, 0);

            // aplica percentual da base
            const baseCalculada = baseSemTributos * percentualBase;

            // calcula imposto
            const valorCbs = baseCalculada * aliquotaCbs;

            this.form.valorBaseCalculoIbsCbs = Math.round(baseCalculada);
            this.form.valorCbs = Math.round(valorCbs);
            this.form.valorUf = Math.round(this.form.valorBaseCalculoIbsCbs * this.parsePercent(this.form.aliquotaUf));

            this.componentKey += 1;
        },

        syncPisCofinsBaseCalculo() {
            const valorProdutos = this.toNumberBR(this.form.valorTotal);
            const icmsProprio = this.toNumberBR(this.form.icmsValor);
            const basePisCofins = Math.max(valorProdutos - icmsProprio, 0);

            this.form.cofinsBaseCalculo = Math.round(basePisCofins);
            this.form.pisBaseCalculo = Math.round(basePisCofins);
        },

        calcularICMS() {
            if (!this.form.ctsIcms) return;

            this.calcQtd()

            this.atualizarBaseCalculoIcmsPorRegra();

            const cts = this.form.ctsIcms.split(' - ')[0];

            if (cts === '40' || cts === '41' || cts === '50') {
                this.form.icmsBaseCalculo = 0
                this.form.resultBaseCalcICMS = 0
                this.form.icmsPercentual = ''
                this.form.icmsValor = 0
                return
            }

            // Base de cálculo: se não informar, usa valor total do produto
            const baseCalc = this.toNumberBR(this.form.icmsBaseCalculo) || this.toNumberBR(this.form.valorTotal);

            // Alíquota (sempre decimal)
            const aliq = this.parsePercent(this.form.icmsPercentual);

            // Percentual de redução (sempre decimal)
            const icmsPercentualBaseCalculo = this.parsePercent(this.form.icmsPercentualBaseCalculo);

            let icms = 0;
            this.form.resultBaseCalcICMS = '';

            switch (cts) {
                case '00': { // Tributada Integralmente
                    icms = baseCalc * aliq;
                    break;
                }

                case '10': {
                    let mva = this.form.modalidadeDeterminacao == '4 - Margem Valor Agregado (%)' ? this.parsePercent(this.form.mva) : 0; // MVA em decimal
                    let aliqDestino = this.parsePercent(this.form.aliqDestinoICMS)
                    if (mva > 1) mva = mva / 100;


                    const baseST = baseCalc * (1 + mva);
                    //console.log("baseST ", baseST)

                    const icmsNormal = baseCalc * aliq;

                    // ICMS-ST
                    icms = (baseST * aliqDestino) - icmsNormal;

                    this.form.resultBaseCalcICMS = Math.round(baseST);
                    break;
                }

                case '20': { // Redução de Base

                    const valorReducao = baseCalc * icmsPercentualBaseCalculo;
                    this.form.resultBaseCalcICMS = Math.round(baseCalc - valorReducao)
                    icms = this.form.resultBaseCalcICMS * aliq
                    break;
                }

            }

            this.form.icmsValor = Math.round(icms);
            this.syncPisCofinsBaseCalculo();

            this.calcularCofins();
            this.calcularPIS();
            this.calcularUF();
            this.calcularIbsCbs();
            this.componentKey += 1;

        },

        calcularCofins() {
            if (!this.form.ctsCofins) return;

            this.calcQtd()

            const cts = this.form.ctsCofins.split(' - ')[0];

            if (cts === '07' || cts === '08' || cts === '09') {
                this.form.cofinsBaseCalculo = 0
                this.form.cofinsPercentual = ''
                this.form.cofinsValor = 0
                return
            }

            this.syncPisCofinsBaseCalculo();

            const baseCalc = this.toNumberBR(this.form.cofinsBaseCalculo);
            // const icmsValor = this.toNumberBR(this.form.icmsValor);
            // const baseSemIcms = Math.max(baseCalc - icmsValor, 0);

            // Alíquota (sempre decimal)
            const aliq = this.parsePercent(this.form.cofinsPercentual);

            let cofins = 0;

            switch (cts) {
                case '00':
                case '01': {
                    cofins = baseCalc * aliq;
                    break;
                }

                case '10': {
                    let mva = this.parsePercent(this.form.mva);
                    if (mva > 1) mva = mva / 100;


                    const baseST = baseCalc * (1 + mva);

                    this.form.icmsBaseCalculoFinal = Math.round(baseST);
                    break;
                }


            }

            this.form.cofinsValor = Math.round(cofins);
            this.calcularIbsCbs();
            this.componentKey += 1;
        },


        calcularPIS() {
            if (!this.form.ctsPis) return;

            const cts = this.form.ctsPis.split(' - ')[0];

            if (cts === '06' || cts === '07' || cts === '08' || cts === '09') {
                this.form.pisBaseCalculo = 0
                this.form.pisPercentual = ''
                this.form.pisValor = 0
                return
            }

            this.syncPisCofinsBaseCalculo();

            const baseCalc = this.toNumberBR(this.form.pisBaseCalculo);

            const aliq = this.parsePercent(this.form.pisPercentual);

            let pis = 0;

            switch (cts) {
                case '00':
                case '01': { // Tributada Integralmente
                    pis = baseCalc * aliq;
                    break;
                }

                case '10': {
                    let mva = this.parsePercent(this.form.mva); // MVA em decimal
                    if (mva > 1) mva = mva / 100;

                    // Base de cálculo ST
                    const baseST = baseCalc * (1 + mva);

                    this.form.icmsBaseCalculoFinal = Math.round(baseST);
                    break;
                }
            }

            // Arredonda somente para exibição
            this.form.pisValor = Math.round(pis);
            this.calcularIbsCbs();
            this.componentKey += 1;

        },

        calcularIPI(){
            if (!this.form.ctsIpi) return;

            this.calcQtd()

            const cts = this.form.ctsIpi.split(' - ')[0];

            if (cts === '01' || cts === '02' || cts === '03' || cts === '04' || cts === '05') {
                this.form.ipiBaseCalculo = 0
                this.form.ipiPercentual = ''
                this.form.ipiValor = 0
                return
            }

            // Base de cálculo: se não informar, usa valor total do produto
            const baseCalc = this.toNumberBR(this.form.ipiBaseCalculo) || this.toNumberBR(this.form.valorTotal);

            const aliq = this.parsePercent(this.form.ipiPercentual);

            let ipi = 0;

            switch (cts) {

                case '00': {
                    ipi = baseCalc * aliq;
                    break
                }

                case '50': {
                    ipi = baseCalc * aliq;
                    break;
                }

                case '10': {
                    const ipiAtual = this.toNumberBR(this.form.ipiValor) || 0;
                    let mva = this.parsePercent(this.form.mva);
                    if (mva > 1) mva = mva / 100;


                    const baseST = (baseCalc + ipiAtual) * (1 + mva);

                    this.form.icmsBaseCalculoFinal = Math.round(baseST);
                    break;
                }


            }

            this.form.ipiValor = Math.round(ipi);
            this.atualizarBaseCalculoIcmsPorRegra();
            this.componentKey += 1;
        },


        calcQtd() {
            // Converte quantidade de forma segura independente se vem como número ou string (inteiro ou fracionado)
            let qtd = 0;
            if (typeof this.form.quantidade === 'number') {
                qtd = this.form.quantidade;
            } else if (typeof this.form.quantidade === 'string') {
                // Remove espaços e converte vírgula em ponto para lidar com decimais
                qtd = Number(this.form.quantidade.trim().replace(',', '.')) || 0;
            } else if (this.form.quantidade) {
                // Tenta converter qualquer outro tipo
                qtd = Number(this.form.quantidade) || 0;
            }
            
            const total = this.toNumberBR(this.form?.valorUnitario?.replaceAll(',', ''));        // já vem 32919942

            console.log('Qtd:', qtd, 'Total:', total, 'Resultado: ',  qtd * total, 'Unitario ', this.form?.valorUnitario);

            this.form.valorTotal = Math.round(qtd * total);

            this.syncPisCofinsBaseCalculo();

            this.atualizarBaseCalculoIcmsPorRegra();

            if(this.addCalc){
                //this.form.icmsBaseCalculo = this.form.valorTotal
                //this.form.cofinsBaseCalculo = this.form.valorTotal
                this.form.ipiBaseCalculo = this.form.valorTotal
                //this.form.pisBaseCalculo = this.form.valorTotal
                this.calcularUF();
                this.calcularIbsCbs();
            }

            this.componentKey += 1;

        },

        async handleAction(actionId) {

            if(this.isNfRemessa) return

            runAction(
            { id: actionId },
            {
                _currentData: { 
                    ...this.form,
                    quantidade: undefined,
                    valorTotal: Number(String(this.form.valorTotal).replace(/\./g, '')?.replace(',', '') || 0) / 100,
                    valorUnitario: Number(String(this.form.valorUnitario).replace(/\./g, '')?.replace(',', '') || 0) / 100,

                }
            },
            ).then(async (result) => {

                if (result?.data?.readonly) {
                    this.readonlyAction = result?.data?.readonly;
                }
                for (const key in result?.data) {

                    if( key === 'valorUnitario' || key === 'valorTotal' || key == 'quantidade') {
                        //this.form[key] = this.form[key] * 100;
                       // this.form[key] = this.form.quantidade
                    } else {
                        this.form[key] = await result?.data[key];
                    }


                    this.componentKey += 1;
                }
            
            }).catch((err) => {
                console.log('Error: ', err)
            });
        },

        parseMoeda(valor) {
            if (!valor) return 0;

            // Remove "R$", espaços e pontos de milhar, troca vírgula por ponto
            return parseFloat(
                valor.toLocaleString()
                ?.replace(/[^\d,.-]/g, '') // remove R$, espaços e outros caracteres
                ?.replace(/\./g, '')       // remove pontos de milhar
                ?.replace(',', '.')        // troca vírgula decimal por ponto
            ) || 0;
        },

        async recalcularAoTrocarTab(newTabValue) {
            this.calcQtd();

            if (this.addCalc) {
                this.calcularIPI();
                this.calcularICMS();
                this.calcularPIS();
                this.calcularCofins();
            }

            if (newTabValue === 5 && (this.notaFiscalItemCST.length === 0 || this.notaFiscalItemClassificacao.length === 0)) {
                await Promise.all([
                    this.getNotaFiscalItemCST(),
                    this.getNotaFiscalItemClassificacao()
                ]);
            }
        }
    },

    watch: {
        async open(value){
            this.dialog = value

            if (value) {
                await this.$nextTick();
                await this.recalcularAoTrocarTab(this.tab);
            }
        },

        isNfReferenciada(isNfRef){
            if (!isNfRef) {
                this.addCalc = !this.isNfRemessa;
            }

            if(isNfRef){
                this.form.icmsBaseCalculo = 0
                this.form.cofinsBaseCalculo = 0
                this.form.ipiBaseCalculo = 0
                this.form.pisBaseCalculo = 0
                this.form.mva = ''
                this.form.icmsPercentual = ''
                this.form.cofinsValor = 0
                this.form.ipiValor = 0
                this.form.ipiPercentual = ''
                this.form.icmsPercentual = ''
                this.form.pisPercentual = ''
                this.form.icmsValor = 0
                this.form.aliquotaUf = ''
                this.form.valorUf = 0
            } else {
                //this.form.icmsBaseCalculo = this.form.valorTotal
                //this.form.cofinsBaseCalculo = this.form.valorTotal
                this.form.ipiBaseCalculo = this.form.valorTotal
                //this.form.pisBaseCalculo = this.form.valorTotal
            }
        },

        isNfRemessa(isRemessa){
            if (isRemessa) {
                this.addCalc = false;
                this.form.icmsBaseCalculo = 0
                this.form.cofinsBaseCalculo = 0
                this.form.ipiBaseCalculo = 0
                this.form.pisBaseCalculo = 0
                this.form.mva = ''
                this.form.icmsPercentual = ''
                this.form.cofinsValor = 0
                this.form.ipiValor = 0
                this.form.ipiPercentual = ''
                this.form.icmsPercentual = ''
                this.form.pisPercentual = ''
                this.form.icmsValor = 0
                this.form.aliquotaUf = ''
                this.form.valorUf = 0
                this.form.valorBaseCalculoIbsCbs = 0
                this.form.valorCbs = 0
                this.form.ipiCompoeBaseCalculo = false
                this.form.freteCompoeBaseCalculo = false
            } else if (!this.isNfReferenciada) {
                this.addCalc = true;
                //this.form.icmsBaseCalculo = this.form.valorTotal
                //this.form.cofinsBaseCalculo = this.form.valorTotal
                this.form.ipiBaseCalculo = this.form.valorTotal
                //this.form.pisBaseCalculo = this.form.valorTotal
            }
        },

        addCalc(value){
            if(!value){
                this.form.icmsBaseCalculo = 0
                this.form.cofinsBaseCalculo = 0
                this.form.ipiBaseCalculo = 0
                this.form.pisBaseCalculo = 0
                this.form.ipiCompoeBaseCalculo = false
                this.form.freteCompoeBaseCalculo = false
                this.form.mva = ''
                this.form.icmsPercentual = ''
                this.form.cofinsValor = 0
                this.form.ipiValor = 0
                this.form.ipiPercentual = ''
                this.form.icmsPercentual = ''
                this.form.pisPercentual = ''
                this.form.icmsValor = 0
                this.form.aliquotaUf = ''
                this.form.valorUf = 0
            } else {
                //this.form.icmsBaseCalculo = this.form.valorTotal
                //this.form.cofinsBaseCalculo = this.form.valorTotal
                this.form.ipiBaseCalculo = this.form.valorTotal
                //this.form.pisBaseCalculo = this.form.valorTotal
            }
        },

        async ['form.valorFrete']() {
            if (!this.form.freteCompoeBaseCalculo) return;
            await this.recalcularAoTrocarTab(this.tab);
        },

        async tab(newTabValue){
            await this.recalcularAoTrocarTab(newTabValue)
        },

        ['form.ncm'](value){
            if (this.isNfRemessa) return

            const searchNcm = this.itemsNcm.filter((ncm) => ncm.codigo === value)[0]
            this.form.cest = this.cests.filter((cest) => cest.descricao === searchNcm?.descricao)[0]?.codigo || this.form.cest
            this.componentKey += 1;
        },

        async ['form.cest'](value){
            if (this.isNfRemessa) return

            const searchCest = this.cests.filter((cest) => cest.codigo === value)[0]
            this.form.ncm = this.itemsNcm.filter((ncm) => ncm.descricao === searchCest?.descricao)[0]?.codigo || this.form.ncm
            this.componentKey += 1;

            await this.$nextTick();
            await this.recalcularAoTrocarTab(this.tab);
        },

        ['form.cfop'](value){
            if(value){
                if(!this.isNfRemessa) this.handleAction("86274cac-4a04-48dd-b2f5-dc4da96744d2");
            }
        },

        async jobSelected(value){
            //
        },

        itemEdit: {
            async handler(value){
                //console.log('itemEdit >>> ', value)

                const possuiItemEmEdicao = value && Object.keys(value).length > 0;
                const parseBooleanFlag = (flag) => {
                    if (flag === true || flag === 1) return true;
                    if (flag === false || flag === 0 || flag == null) return false;
                    const texto = String(flag).trim().toLowerCase();
                    return texto === 'true' || texto === '1';
                };
                let itemBase = value || {};

                if (
                    itemBase?.id &&
                    (itemBase?.ipiCompoeBaseCalculo == null || itemBase?.freteCompoeBaseCalculo == null)
                ) {
                    try {
                        let registroCompleto = null;

                        try {
                            const responseById = await Vue.prototype.$http.get(`/Entity/FisPreDocEmiItem/${itemBase.id}`);
                            registroCompleto = responseById?.data?.data || null;
                        } catch (_) {
                            // fallback para ambientes onde o endpoint por id não retorna o shape esperado
                        }

                        if (!registroCompleto) {
                            const response = await Vue.prototype.$http.get('/Entity/FisPreDocEmiItem/search-fields', {
                                params: {
                                    ids: String(itemBase.id),
                                    page: 1,
                                    limit: 1
                                }
                            });

                            registroCompleto = response?.data?.data?.data?.data?.[0]
                                || response?.data?.data?.data?.[0]
                                || response?.data?.data?.[0]
                                || response?.data?.[0]
                                || null;
                        }

                        if (registroCompleto) {
                            itemBase = {
                                ...registroCompleto,
                                ...itemBase,
                                ipiCompoeBaseCalculo:
                                    itemBase?.ipiCompoeBaseCalculo ?? registroCompleto?.ipiCompoeBaseCalculo,
                                freteCompoeBaseCalculo:
                                    itemBase?.freteCompoeBaseCalculo ?? registroCompleto?.freteCompoeBaseCalculo,
                            };
                        }
                    } catch (error) {
                        console.error('Erro ao hidratar item da NF:', error);
                    }
                }

                const ipiCompoeBaseCalculo = parseBooleanFlag(itemBase?.ipiCompoeBaseCalculo);
                const freteCompoeBaseCalculo = parseBooleanFlag(itemBase?.freteCompoeBaseCalculo);

                this.form = {
                    ...itemBase,
                    valorUnitario: itemBase.valorUnitario,
                    valorTotal: itemBase.valorTotal,
                    ipiCompoeBaseCalculo,
                    freteCompoeBaseCalculo,
                    aliquotaCbs: itemBase.aliquotaCbs ?? '',
                    valorCbs: itemBase.valorCbs ?? itemBase.valorBaseCalculoIbsCbs ?? 0,
                    aliquotaUf: itemBase?.aliquotaUf ?? (itemBase?.uf?.aliquota != null ? String(itemBase.uf.aliquota) : ''),
                    valorUf: itemBase?.valorUf ?? itemBase?.uf?.valor ?? 0,
                }

                if (possuiItemEmEdicao && !this.isNfRemessa && (ipiCompoeBaseCalculo || freteCompoeBaseCalculo || this.isNfReferenciada)) {
                    // Ao reabrir item existente, mantém as abas de impostos visíveis.
                    this.addCalc = true;
                }

                if (this.isNfRemessa) {
                    this.form.ipiPercentual = ''
                    this.form.ipiBaseCalculo = 0
                    this.form.ipiValor = 0
                    this.form.icmsPercentual = ''
                    this.form.icmsBaseCalculo = 0
                    this.form.icmsValor = 0
                    this.form.resultBaseCalcICMS = 0
                    this.form.pisPercentual = ''
                    this.form.pisBaseCalculo = 0
                    this.form.pisValor = 0
                    this.form.cofinsPercentual = ''
                    this.form.cofinsBaseCalculo = 0
                    this.form.cofinsValor = 0
                    this.form.percentualBaseCalculoIbsCbs = ''
                    this.form.valorBaseCalculoIbsCbs = 0
                    this.form.aliquotaCbs = ''
                    this.form.valorCbs = 0
                    this.form.aliquotaUf = ''
                    this.form.valorUf = 0
                }

                if(!this.isNfRemessa && !this.isNfReferenciada){
                    this.calcQtd()
                    this.componentKey += 1;
                }
            },
            deep: true,
            immediate: true
        }
    },

    async created() {
        await Promise.all([
            this.getNcms(),
            this.getCests(),
            this.getNotaFiscalItemCST(),
            this.getNotaFiscalItemClassificacao(),
        ])
    }
}
</script>

<style scoped>
.ibs-cbs-summary-card {
    padding: 20px;
    border-radius: 14px;
    background: linear-gradient(180deg, #fbfdff 0%, #f3f7fb 100%);
    border-color: #d9e4f2 !important;
}

.ibs-cbs-summary-card__title {
    margin-bottom: 12px;
    font-size: 0.95rem;
    font-weight: 600;
    color: #17324d;
}

.ibs-cbs-formula {
    margin-bottom: 8px;
    line-height: 1.5;
    color: #41576d;
}

.ibs-cbs-metric {
    height: 100%;
    padding: 14px;
    border: 1px solid #d9e4f2;
    border-radius: 12px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.ibs-cbs-metric--highlight {
    border-color: #1976d2;
    box-shadow: 0 8px 24px rgba(25, 118, 210, 0.08);
}

.ibs-cbs-metric__label {
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #5f6b7a;
}

.ibs-cbs-metric__value {
    font-size: 1rem;
    color: #17324d;
}
</style>
